import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button";
import { IconEdit, IconTrash } from "@/components/icons";
import Input from "@/components/inputs/Input";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";
import BackButton from "@/components/staff/BackButton";

import { useGetUser } from "@/hooks/api/user.hooks";
import useModalRouter from "@/hooks/useModalRouter";

const StaffUserSettingsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useGetUser();
  const { openModal } = useModalRouter();

  return (
    <section className="staff-section-container">
      <div className="max-lg:space-y-[1.875rem]">
        <BackButton />
        <h1 className={"staff-section-title mb-6"}>{t("account.title")}</h1>
        {data && (
          <div className="flex max-w-[25rem] flex-col gap-4">
            <Input
              type={"button"}
              placeholder={data.username}
              className="text-on-primary w-full"
              readOnly
              inputSize={"medium"}
              required
              disabled
            />

            <Input
              type={"button"}
              icon={<IconEdit />}
              placeholder={"**********"}
              className="text-on-primary w-full"
              required
              onClick={() => openModal(MODAL_ROUTES.CHANGE_PASSWORD)}
              readOnly
              inputSize={"medium"}
            />

            <Button
              className="text-[#BB191A] hover:text-white"
              type="button"
              color="black"
              onClick={() => openModal(MODAL_ROUTES.DELETE_ACCOUNT)}
              size="medium"
            >
              <div className="flex items-center justify-center gap-2">
                <IconTrash className="group-hover:stroke-on-primary stroke-[#BB191A] transition-all" />
                {t("account.delete-account")}
              </div>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default StaffUserSettingsPage;
